export default __webpack_public_path__ + "static/media/neqas-logo.2c5aa975.jpeg";